export const autoSubFlags = [
  { mainFlagId: 55, subFlags: [54, 36] },
  // بیمه
  { mainFlagId: 1136, subFlags: [2556, 1720, 1721, 1722] },

  // مواجهه با شکست‌ها
  { mainFlagId: 1341, subFlags: [1695, 1696] },

  // ناراضی از روابط
  { mainFlagId: 1194, subFlags: [1732, 1733, 1734, 1735, 1736] },

  // درگذشت اطرافیان
  { mainFlagId: 1141, subFlags: [1726, 1728, 1729, 1727] },

  // بیماری اطرافیان
  { mainFlagId: 1195, subFlags: [1712, 1714, 1715, 1713] },

  // دیدن، شنیدن و خواندن"
  { mainFlagId: 507, subFlags: [1758, 1756, 461] },
];
